import { FC, PropsWithChildren } from 'react';

import styles from './section.module.scss';

type Props = PropsWithChildren & { title?: string };

const Section: FC<Props> = ({ children, title }) => (
  <section className={styles.section}>
    {title && <div className={styles.title}>{title}</div>}
    {children}
  </section>
);

export default Section;
